import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_QUOTA, GET_QUOTA_SUCCESS, GET_QUOTA_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getQuota({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { membershipId, benefitGroupConfigId } = payload?.urlParams;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/membership/${membershipId}/benefit-group-configs/${benefitGroupConfigId}/quota-summary`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_QUOTA_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_QUOTA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_QUOTA_ERROR, payload: error });
  }
}

export function* watchGetQuota() {
  yield takeEvery(GET_QUOTA, getQuota);
}

function* getQuotaSaga() {
  yield all([fork(watchGetQuota)]);
}

export default getQuotaSaga;
